export const ignoreRevalidationPages = ['onSpot'];
